module.exports = __webpack_public_path__ + "img/turtle-bg.6f2ee7ad.png";